require('./bootstrap');

require('lightgallery/src/js/lightgallery');
require('lg-zoom/src/lg-zoom');
require('lg-thumbnail/src/lg-thumbnail');
